import store from "../store";
import UserService from "@/services/UserService";

export default {
  async InitializeApplication() {
    await store.dispatch("getActiveEnvironment");
    if (store.state.activeEnvironment.id) {
      await this.checkCurrentEnvironment();
      await store.dispatch("getTermsAndConditions");
      await store.dispatch("loadInitialState");
      await store.dispatch("loadCarousels");
      await store.dispatch("getUser");
      await store.dispatch("getUserEnvironments");
      await store.dispatch("loadCustomerFacets");
      await store.dispatch("getDownloadFormats");
      await this.loadCustomBranding();
    }
  },
  async checkCurrentEnvironment() {
    if (store.state.activeEnvironment.partnerZoneUrl && window.location.hostname != "localhost" && window.location.hostname != "test-occtoo-partnerzone.azurewebsites.net") {
      let url = new URL(store.state.activeEnvironment.partnerZoneUrl);
      if (window.location.host != url.host) {
        window.location.href =
          store.state.activeEnvironment.partnerZoneUrl +
          "#/id_token=" +
          localStorage.getItem("token");
      }
    }
  },
  async loadCustomBranding() {
    const response = await UserService.GetBrandingForCustomer(store.state.activeEnvironment.id);

    const branding = response.data.result;

    document.documentElement.style.setProperty("--pz-iconbox-color", "#F59B00");

    if (branding.logoUrl !== undefined && branding.logoUrl !== "") {
      document.documentElement.style.setProperty(
        "--pz-logo-image-url",
        "url(" + branding.logoUrl + ")"
      );
    } else {
      document.documentElement.style.setProperty(
        "--pz-logo-image-url",
        "url(/img/logo-default.png)"
      );
    }

    if (branding.backgroundImageUrl !== undefined && branding.backgroundImageUrl !== "") {
      document.documentElement.style.setProperty(
        "--pz-background-image-url",
        "url(" + branding.backgroundImageUrl + ")"
      );
    } else {
      document.documentElement.style.setProperty(
        "--pz-background-image-url",
        "url(/img/background.jpg)"
      );
    }

    if (
      branding.feedbackLogoUrl &&
      branding.feedbackLogoUrl !== undefined &&
      branding.feedbackLogoUrl !== ""
    ) {
      document.documentElement.style.setProperty(
        "--pz-fedback-logo-image-url",
        "url(" + branding.feedbackLogoUrl + ")"
      );
    } else {
      document.documentElement.style.setProperty(
        "--pz-fedback-logo-image-url",
        "url(/img/logo-black.png)"
      );
    }

    Object.keys(branding.cssProperties).forEach(css => {
      document.documentElement.style.setProperty("--" + css, branding.cssProperties[css]);
    });
  }
};
